/**
 * Einstellungen der Anzeige, die die Fahrt überdauern.
 *
 * Bisher gab es davon eine — die Sprachansage, die ihre eigene Ablage führt.
 * Mit der zusammenklappbaren Zustandsleiste kam die zweite dazu, und ab zwei
 * gehört es an eine Stelle.
 *
 * Alles hier ist eine Vorliebe, kein Zustand: Geht die Ablage verloren, gilt
 * wieder die Vorgabe, und niemand verliert etwas außer einer Bequemlichkeit.
 */
const LEISTE_KEY = 'konvoi.leiste';

/**
 * Steht die Zustandsleiste offen?
 *
 * Vorgabe ist **offen**: Wer die App zum ersten Mal öffnet, soll sehen, dass
 * sie verbunden ist. Wer sie zuklappt, findet sie beim nächsten Mal zugeklappt
 * vor — dieselbe Zusage wie bei der Ansage.
 */
export function leisteOffen(): boolean {
  try {
    return window.localStorage.getItem(LEISTE_KEY) !== 'zu';
  } catch {
    return true;
  }
}

export function setLeisteOffen(offen: boolean): void {
  try {
    window.localStorage.setItem(LEISTE_KEY, offen ? 'auf' : 'zu');
  } catch {
    // Ohne Ablage gilt die Wahl für diese Fahrt. Kein Grund, sie abzulehnen.
  }
}

const PRUEFMODUS_KEY = 'konvoi.pruefmodus';

/**
 * Zeigt die App zusätzlich, was das Gerät selbst über sein Netz meldet?
 *
 * Für Prüffahrten (A-139). Die Zustandsleiste bekommt dann ein weiteres
 * Merkmal, „Gerät meldet offline" — neben „Keine Verbindung", das die App aus
 * ihrem Herzschlag schließt. Wer den Unterschied nicht kennt, sähe zwei
 * ähnliche Hinweise; deshalb ist das aus, bis es jemand einschaltet.
 *
 * Mitgeschrieben wird in beiden Fällen: Das Protokoll auf dem Server hängt
 * nicht an diesem Schalter.
 */
export function pruefmodusAn(): boolean {
  try {
    return window.localStorage.getItem(PRUEFMODUS_KEY) === 'an';
  } catch {
    return false;
  }
}

export function setPruefmodus(an: boolean): void {
  try {
    window.localStorage.setItem(PRUEFMODUS_KEY, an ? 'an' : 'aus');
  } catch {
    // Ohne Ablage bleibt er aus — die Vorgabe. Mehr ist nicht verloren.
  }
}
